import axios from 'axios';
import authHeader from './auth-header';

const APP_URL = process.env.APP_URL;

class UserService {
    getPublicContent() {
        return axios.get(APP_URL + 'all');
    }

    getUserBoard() {
        return axios.get(APP_URL + 'user', {headers: authHeader()});
    }

    getModeratorBoard() {
        return axios.get(APP_URL + 'mod', {headers: authHeader()});
    }

    getAdminBoard() {
        return axios.get(APP_URL + 'admin', {headers: authHeader()});
    }
    getPdfFile(){
        return axios.get(APP_URL +'download/pdf"', {headers: authHeader() , ...{responseType: 'blob'}});
    }
}

export default new UserService();
